
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("200NX", function(module, exports) {

$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $52ea49f8e16543b5$export$7b31a9938ec3ba75; });
const $52ea49f8e16543b5$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("1EY4W", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $7d8dc248ee764d66$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $hOqV7 = parcelRequire("hOqV7");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $200NX = parcelRequire("200NX");

var $kNCWT = parcelRequire("kNCWT");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $1FD73 = parcelRequire("1FD73");

var $6wlNh = parcelRequire("6wlNh");

var $k2OeR = parcelRequire("k2OeR");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-8ecd229bc4";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $7d8dc248ee764d66$var$BASE_URL = "https://www.atlassian.com";
const $7d8dc248ee764d66$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $7d8dc248ee764d66$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $200NX.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $1FD73.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $hOqV7.loadQuery)(relayEnvironment, query, queryVars);
        const page = /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hOqV7.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "canonical",
                        href: `${$7d8dc248ee764d66$var$BASE_URL}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$7d8dc248ee764d66$var$BASE_URL}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $7d8dc248ee764d66$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                            rel: "alternate",
                            href: `${$7d8dc248ee764d66$var$BASE_URL}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("1FD73", function(module, exports) {

$parcel$export(module.exports, "initRelayEnvironment", function () { return $7d9774703a666878$export$1456be3de97c862f; });

var $4PJsz = parcelRequire("4PJsz");
(0, $4PJsz.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $7d9774703a666878$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride !== null && baseUrlOverride !== void 0 ? baseUrlOverride : $7d9774703a666878$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $4PJsz.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $4PJsz.Network).create(fetchResponse);
    const store = new (0, $4PJsz.Store)(new (0, $4PJsz.RecordSource)(initialRecords));
    return new (0, $4PJsz.Environment)({
        network: network,
        store: store
    });
}
let $7d9774703a666878$var$clientSideRelayEnvironment;
function $7d9774703a666878$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $7d9774703a666878$var$clientSideRelayEnvironment !== null && $7d9774703a666878$var$clientSideRelayEnvironment !== void 0 ? $7d9774703a666878$var$clientSideRelayEnvironment : $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$7d9774703a666878$var$clientSideRelayEnvironment) $7d9774703a666878$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $4PJsz.RecordSource)(initialRecords));
    return $7d9774703a666878$var$clientSideRelayEnvironment;
}

});


parcelRegister("aSYwy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateCategoryRelayPage", function () { return $e184c1faf91327e3$export$edf498f6a1736180; });

var $loA2J = parcelRequire("loA2J");

var $dH3QU = parcelRequire("dH3QU");
const $e184c1faf91327e3$export$edf498f6a1736180 = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageTemplate), {
        queryRef: queryRef
    });
};

});


var $200NX = parcelRequire("200NX");

var $1EY4W = parcelRequire("1EY4W");

var $aSYwy = parcelRequire("aSYwy");

var $dH3QU = parcelRequire("dH3QU");
(0, $1EY4W.init)((0, $aSYwy.ConfluenceTemplateCategoryRelayPage), (0, $dH3QU.ConfluenceTemplatesUnifiedRelayPageQuery), (0, $dH3QU.getConfluenceTemplatesUnifiedRelayPageQueryVars)(window.location), (0, $200NX.RELAY_API_CONTENTFUL));


//# sourceMappingURL=confluence-template-category-contentful-relay-page.1707354c.js.map
